module.exports = __webpack_public_path__ + "img/guide-shopping.1b672ca5.gif";